class ARIAAnnouncementManager {
  private static instance: ARIAAnnouncementManager

  private ELEMENT_ID = 'aria-live-assertive'

  static getInstance(): ARIAAnnouncementManager {
    if (!ARIAAnnouncementManager.instance) {
      ARIAAnnouncementManager.instance = new ARIAAnnouncementManager()
    }
    return ARIAAnnouncementManager.instance
  }

  createMockingAriaElement() {
    if (!document.getElementById(this.ELEMENT_ID)) {
      const region = document.createElement('div')
      region.id = this.ELEMENT_ID
      region.setAttribute('aria-live', 'assertive')
      region.setAttribute('role', 'alert')
      region.setAttribute('aria-atomic', 'true')
      region.className = 'sr-only'
      document.body.appendChild(region)
    }
  }

  announce(message: string) {
    const region = document.getElementById(this.ELEMENT_ID)
    if (region) {
      region.textContent = ''
      region.textContent = message
    }
  }

  clearContent() {
    const region = document.getElementById(this.ELEMENT_ID)
    if (region) {
      region.setAttribute('aria-live', 'off')
      region.textContent = ''
      region.setAttribute('aria-live', 'assertive')
    }
  }
}

const ariaAnnouncementManager = ARIAAnnouncementManager.getInstance()

export default ariaAnnouncementManager
